import React, { Component } from 'react';
import Divider from '@material-ui/core/Divider';
import setting2 from '../../../../assets/icons/setting2.svg';

import './Header.css';

export default class Header extends Component {
  render() {
    const { setOpenSetting, setOpenPanel } = this.props;
    return (
      <div className="header d-flex">
        <div className="header__right d-flex">
          <div className="header__cover">
          </div>
          <button>امروز</button>
        </div>
        <div className="header__left d-flex">
          <div className="ml-2"><img src={setting2} onClick={() => setOpenSetting()} /></div>
          <div className="header__left--show ml-2 d-flex">
            <button>نمایش هفتگی</button>
          </div>
          <div className="header__left--add">
            <button onClick={() => setOpenPanel()}>اضافه کردن رویداد یا وظیفه +</button>
          </div>
        </div>
      </div >
    );
  }
}